export default __webpack_public_path__ + "static/media/onboarding-gc.3da6aa7e.png";